  <div class="questionnaire-container">    
    <true-breadcrumbs [subset]="this.config.subset" [assessmentName]="assessmentName + ' (' + assessmentObject + ')'"></true-breadcrumbs>
    <!-- Lean Canvas Section -->
    <!-- TODO: replace image with interactive canvas - click to select section as with drop-down -->    
    <div class="questionnaire-layout">
      <div class="questionnaire-image">
        <img src="assets/canvas2x.png" alt="Lean Canvas" />
      </div>
      <div class="questionnaire-instructions">
        <h2>Structure and Simplicity</h2>
        <p>
          The Lean Canvas is designed to provide a concise, one-page overview of the business model. 
          It focuses on key elements such as problem, solution, unique value proposition, customer segments, and revenue streams.
        </p>
        <h2>High-Level Overview</h2>
        <p>
          It serves as a strategic tool to quickly communicate the essence of the business model and identify potential areas for development or refinement.
        </p>
      </div>        
    </div>    
    
    <ng-template [ngIf]="selectedSection">
      <div class="questionnaire-flex-layout section-selection">
        <!-- First Column: Display Selected Section Content -->          
        <div class="questionnaire-column">
          <div class="header-with-actions">
            <h2>Section selection</h2>
            <span class="spacer"></span>
            <button title="Previous section" mat-icon-button aria-label="Undo" (click)="previousSection()">
              <mat-icon>navigate_before</mat-icon>
            </button>
            <button title="Select section" mat-icon-button (click)="openSectionOverview()" aria-label="Open section list">
              <mat-icon>view_list</mat-icon>
            </button>
            <button title="Next section" mat-icon-button aria-label="Redo" (click)="nextSection()">
              <mat-icon>navigate_next</mat-icon>
            </button>
          </div>        
        </div>
      </div>
      <h2 style="margin: 16px;" class="questionnaire-section-title canvas">
        {{ selectedSection.questionTitle | moveNumberToFront }}
      </h2>
      <div class="questionnaire-last-saved" [ngClass]="{'questionnaire-animation': animate}" (animationend)="onAnimationEnd()" *ngIf="lastSaveTime">
        Last saved at: {{ lastSaveTime }}
      </div>
      <div class="questionnaire-section-content">
        <div class="questionnaire-flex-layout">
          <!-- First Column: Display Selected Section Content -->          
          <div class="questionnaire-column">
            <div class="header-with-actions">
              <h2>Instructions</h2>
              <span class="spacer"></span>
              <!--<button title="Previous section" mat-icon-button aria-label="Undo" (click)="previousSection()">
                <mat-icon>navigate_before</mat-icon>
              </button>
              <button title="Select section" mat-icon-button (click)="openSectionOverview()" aria-label="Open section list">
                <mat-icon>view_list</mat-icon>
              </button>
              <button title="Next section" mat-icon-button aria-label="Redo" (click)="nextSection()">
                <mat-icon>navigate_next</mat-icon>
              </button>-->
            </div>
            <p [innerHTML]="selectedSection.description"></p>            
          </div>
      
          <!-- Second Column: Long Text Input Field -->          
          <div class="questionnaire-column">
            <div class="header-with-actions">
              <h2>Your input</h2>
              <span class="spacer"></span>
              <button title="Undo" mat-icon-button aria-label="Undo" (click)="undo()">
                <mat-icon>undo</mat-icon>
              </button>
              <button title="Redo" mat-icon-button aria-label="Redo" (click)="redo()">
                <mat-icon>redo</mat-icon>
              </button>
            </div>
          
            <mat-form-field appearance="fill" class="full-width">
              <!--<mat-label>Explain in as much detail as possible your answer</mat-label>-->
              <textarea matInput rows="30" class="custom-textarea" [(ngModel)]="selectedSection.answer" (input)="onInputChange()"></textarea>
            </mat-form-field>
          </div>
      
          <!-- Third Column: Backend Text Display -->
          <div class="questionnaire-column">            
            <div class="header-with-actions">
              <h2>AI assistant recommendation</h2>
              <span class="spacer"></span>
              <button title="Get recommendations"                              
                      mat-icon-button
                      aria-label="get-recommendations"
                      (click)="getRecommendations()"
                      [disabled]="recommendationsLoading">
                
                <mat-icon *ngIf="!recommendationsLoading">auto_awesome</mat-icon>
                
                <mat-progress-spinner *ngIf="recommendationsLoading"
                                      class="spinner-icon"
                                      mode="indeterminate"
                                      diameter="24"
                                      strokeWidth="3"
                                      color="primary">
                </mat-progress-spinner>
              </button>
            </div>
            <p [innerHTML]="selectedSection.recommendations"></p>
          </div>
        </div>
      </div>
    </ng-template>
  </div>